module.exports = __webpack_public_path__ + "img/67_27.1b1087dd.png";